"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.clyde.description': 'Hombre británico con poder, matices y humor.',
};
